<div id="all" *ngIf="email">
  <header class="header">
    <div class="close-button" onclick="history.back()"></div>
    <h1>
      <p>Station IDでログイン</p>
    </h1>
  </header>

  <div class="container">
    <div class="container-item">
      <div>
        <p class="base-text">
          入力されたEメールアドレスは既にStation IDに登録されています。
          <br />
          ご登録済みのStation IDでログインしてください。
        </p>
      </div>
      <div>
        <p class="base-title-text">メールアドレス</p>
        <p class="base-text">{{ email }}</p>
      </div>

      <button class="white" (click)="clickLoginButton()">ログイン</button>
    </div>
  </div>
</div>
